module.exports = __webpack_public_path__ + "static/media/folder-line-icon.75fdaa4c.svg";